import React, { useState } from "react";
import Styles from "./Navigation.module.css";

import { useNavigate } from "react-router-dom";
import userSvg from "../../images/user.svg";
import hamburger from "../../images/hamburger.svg";
import RightSideModal from "../../components/RightSideModal/RightSideModal";

const Navigation = ({ setStockSymbol, setOpenModal }) => {
  const navigate = useNavigate();
  const [rightSideModal, setRightSideModal] = useState(false);

  const handleNavigateAbout = () => {
    window.open("https://www.levelfields.ai/about", "_blank");
  };

  const handleNavigateNews = () => {
    window.open("https://fintechnews.levelfields.ai/");
  };

  const navOptions = [
    {
      name: "Home",
      path: "/",
    },
    {
      name: "FAQ",
      path: "/faq",
    },
    {
      name: "Contact us",
      path: "/contact-us",
    },
    {
      name: "About Us",
      func: handleNavigateAbout,
    },
    {
      name: "Blog",
      path: "/blog",
    },
    {
      name: "News",
      func: handleNavigateNews,
    },
    {
      name: "Login",
      path: "/login",
    },
  ];

  return (
    <div className={Styles.Navigation}>
      <div className={Styles.NavigationContent}>
        <h2 onClick={() => navigate("/")}>13G Reports</h2>
        <div className={Styles.RightSideNav}>
          <ul className={Styles.NavigationList}>
            <li onClick={() => navigate("/")}>Home</li>
            <li onClick={() => navigate("/faq")}>FAQ</li>
            <li onClick={() => navigate("/contact-us")}>Contact us</li>
            <li onClick={handleNavigateAbout}>About Us</li>
            <li onClick={() => navigate("/blog")}>Blog</li>
            <li onClick={handleNavigateNews}>News</li>
            <li onClick={() => navigate("/login")}>
              <img src={userSvg} alt="user" width={20} height={20} />
            </li>
          </ul>
          <div
            className={Styles.Hamburger}
            onClick={() => setRightSideModal(true)}
          >
            <img src={hamburger} alt="hamburger" width={20} />
          </div>
        </div>

        {/* <div className={Styles.RightSideNav}>
          {pathname === "/" ? (
            <>
              <div className={Styles.SearchBar}>
                <Input
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder={"Search Symbol..."}
                />
              </div>
              <div className={Styles.Buttons}>
                <Button
                  style={{
                    height: "40px",
                  }}
                  variant={"black"}
                  onClick={() => setOpenModal((prev) => !prev)}
                >
                  Download
                </Button>
              </div>
            </>
          ) : null}
        </div> */}
      </div>
      <RightSideModal
        open={rightSideModal}
        setOpen={setRightSideModal}
        options={navOptions}
      />
    </div>
  );
};

export default Navigation;
